<div class="sectionname"><span>{{ all_data.name }} Documents</span></div>
<section class="news-page-wrap" *ngIf="ayList.length > 0">
  <!-- <div class="select-list d-flex">
    <label>Select Financial Year</label>
    <select class="input-group-prepend form-control current-text" (change)="onOptionsSelected($event.target.value)">
      <option *ngFor="let ay of ayList" [value]="ay" [selected]="ay == selectedYear">
        <span>FY {{ ay }}</span>
      </option>
    </select>
  </div> -->
  <div class="wrap-section" *ngIf="bss_product_list.length > 0">
    <!-- <div class="roc-row-list row">
      <div *ngFor="let bss of bss_product_list"
        class="col-12 col-md-6 col-lg-6">
        <div class="bg-white" *ngIf="bss.enable">
          <app-blur-field
            [product]="bss"
            [companyName]="all_data.name">
          </app-blur-field>
        </div>
      </div>
      <div
        *ngFor="let pls of pls_product_list"
        class="col-12 col-md-6 col-lg-6">
        <div class="bg-white" *ngIf="pls.enable">
          <app-blur-field
            [product]="pls"
            [companyName]="all_data.name"
          ></app-blur-field>
        </div>
      </div>
    </div> -->

    <div *ngFor="let ay of ayList">
      <h2 class="sec-title">AY - {{ay}}</h2>
      <div class="wrap-free-graph" style="margin-top:10px;margin-bottom: 10px;" *ngFor="let bss of getFilteredPLS(ay)">
        <app-blur-field *ngIf="bss.enable" [product]="bss" [companyName]="all_data.name"></app-blur-field>
      </div>
      <div class="wrap-free-graph" style="margin-top:10px;margin-bottom: 10px;" *ngFor="let pls of getFilteredBSS(ay)">
        <app-blur-field *ngIf="pls.enable" [product]="pls" [companyName]="all_data.name"></app-blur-field>
      </div>
    </div>

    <!-- <div class="wrap-free-graph" style="margin-top:10px;margin-bottom: 10px;" *ngFor="let bss of all_data.bss_product_list">
      <app-blur-field *ngIf="bss.enable" [product]="bss" [companyName]="all_data.name"></app-blur-field>
    </div>
    <div class="wrap-free-graph" style="margin-top:10px;margin-bottom: 10px;" *ngFor="let pls of all_data.pls_product_list">
      <app-blur-field *ngIf="pls.enable" [product]="pls" [companyName]="all_data.name"></app-blur-field>
    </div> -->
  </div>
</section>
